/*
 * Wide header menus: hover on desktop, tap on touch, Escape to close.
 * Do not rely on hover alone — phones have no hover.
 */

export function initMegaMenus() {
    const nav = document.querySelector("[data-site-nav]");
    if (!nav) return;

    const triggers = [...nav.querySelectorAll("[data-mega-open]")];
    const panels = [...nav.querySelectorAll("[data-mega-panel]")];
    const canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    let timer = 0;

    const close = () => {
        triggers.forEach((btn) => btn.setAttribute("aria-expanded", "false"));
        panels.forEach((panel) => panel.classList.remove("is-open"));
    };

    const open = (key) => {
        window.clearTimeout(timer);
        close();
        const btn = nav.querySelector(`[data-mega-open="${key}"]`);
        const panel = nav.querySelector(`[data-mega-panel="${key}"]`);
        btn?.setAttribute("aria-expanded", "true");
        panel?.classList.add("is-open");
    };

    triggers.forEach((btn) => {
        const key = btn.dataset.megaOpen;

        btn.addEventListener("click", (event) => {
            event.preventDefault();
            const expanded = btn.getAttribute("aria-expanded") === "true";

            // Hover already opened the panel. A click should not slam it shut.
            if (canHover) {
                if (!expanded) open(key);
                return;
            }

            if (expanded) close();
            else open(key);
        });

        if (!canHover) return;

        btn.addEventListener("mouseenter", () => open(key));
        btn.addEventListener("mouseleave", () => {
            timer = window.setTimeout(close, 200);
        });
    });

    panels.forEach((panel) => {
        if (!canHover) return;

        panel.addEventListener("mouseenter", () => window.clearTimeout(timer));
        panel.addEventListener("mouseleave", () => {
            timer = window.setTimeout(close, 200);
        });
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") close();
    });

    document.addEventListener("click", (event) => {
        if (!event.target.closest("[data-site-nav]")) close();
    });

    // Accordion blocks inside the hamburger. One section open at a time.
    nav.querySelectorAll("[data-nav-accordion]").forEach((btn) => {
        btn.addEventListener("click", () => {
            const willOpen = btn.getAttribute("aria-expanded") !== "true";
            const panelId = btn.getAttribute("aria-controls");

            nav.querySelectorAll("[data-nav-accordion]").forEach((other) => {
                other.setAttribute("aria-expanded", "false");
                document.getElementById(other.getAttribute("aria-controls"))?.classList.add("hidden");
            });

            if (!willOpen) return;

            btn.setAttribute("aria-expanded", "true");
            document.getElementById(panelId)?.classList.remove("hidden");
        });
    });

    nav.querySelector("[data-site-nav-toggle]")?.addEventListener("click", close);

    nav.querySelectorAll("[data-modal-open]").forEach((btn) => {
        btn.addEventListener("click", close);
    });
}
